var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["scrollbar", _vm.scrollbarModel.type],
      style: { width: _vm.styleWidth + "px" },
    },
    [
      _c("div", { ref: "scrollSpace", staticClass: "scrollspace" }, [
        _c(
          "div",
          {
            staticClass: "scrollhandle",
            style: { left: "calc(" + _vm.scrollPercentage + "% - 20px)" },
            on: {
              mousedown: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.startDrag.apply(null, arguments)
              },
              touchstart: function ($event) {
                $event.preventDefault()
                return _vm.startDrag.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "scrollhandle-block", style: _vm.handleStyle },
              [
                _vm.scrollbarModel.type != "colors"
                  ? _c("i", { staticClass: "material-icons" }, [
                      _vm._v("\n\t\t\t\t\tunfold_more\n\t\t\t\t"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.scrollbarModel.type == "size"
                  ? _c("span", { staticClass: "scrollhandle-subscript" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.handleText) + "\n\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.scrollbarModel.type == "colors"
          ? _c(
              "div",
              { staticClass: "colors" },
              _vm._l(_vm.scrollbarModel.values, function (value, index) {
                return _c("div", { key: index }, [
                  _c("div", {
                    staticClass: "color",
                    style: {
                      width:
                        _vm.styleWidth / _vm.scrollbarModel.values.length +
                        "px",
                      background: value || "transparent",
                    },
                  }),
                ])
              }),
              0
            )
          : _vm.scrollbarModel.type == "size" ||
            _vm.scrollbarModel.type == "scale"
          ? _c("div", {
              staticClass: "value",
              style: { width: _vm.scrollPercentage + "%" },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subscript" }, [
        _c("div", { staticClass: "min" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.scrollbarModel.type == "scale" ? "-" : " ") +
              "\n\t\t"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "label" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.subscript) + "\n\t\t"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "max" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.scrollbarModel.type == "scale" ? "+" : " ") +
              "\n\t\t"
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }